var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5936 6.41664C11.7588 6.06677 11.8511 5.67737 11.8511 5.50215C11.8511 3.98337 10.5886 2.75195 9.03146 2.75195C7.47439 2.75195 6.21191 3.98337 6.21191 5.50215C6.21191 7.02086 7.62172 8.01726 9.03146 8.01726C9.93326 8.01726 10.7359 7.60502 11.2508 6.96314C11.3857 6.79529 11.5014 6.61198 11.5936 6.41664ZM9.03146 6.6422C9.38392 6.6422 9.70612 6.51596 9.95389 6.30715C10.2527 6.05538 10.3842 5.68274 10.3842 5.50215C10.3842 4.74276 9.81072 4.12702 9.03146 4.12702C8.25227 4.12702 7.615 4.74172 7.615 5.50111C7.615 6.02549 8.25227 6.6422 9.03146 6.6422Z",
    fill: "#2A86FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0637756 5.67626C0.052761 5.66351 0.0747902 5.68965 0.0637756 5.67626C-0.0224028 5.56606 -0.0202339 5.43504 0.0641633 5.32355C0.0703456 5.31539 0.0766456 5.30692 0.0830287 5.29825C2.61762 1.83971 5.76073 0 9.00983 0C12.2556 0 15.3959 1.83476 17.9277 5.28634C17.9758 5.35182 18 5.41912 18 5.49968C18 5.58418 17.9718 5.65523 17.9213 5.72395C15.3901 9.16895 12.2526 11 9.00983 11C5.75247 11 2.60112 9.15155 0.0637756 5.67626ZM2.03475 5.08103C1.82638 5.32316 1.82638 5.67613 2.03475 5.91832C4.20519 8.44043 6.64906 9.62494 9.00983 9.62494C11.3707 9.62494 13.8145 8.44043 15.985 5.91832C16.1934 5.67613 16.1934 5.32316 15.985 5.08103C13.8145 2.55896 11.3707 1.37508 9.00983 1.37508C6.64906 1.37508 4.20519 2.55896 2.03475 5.08103Z",
    fill: "#2A86FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/ShowIcon.d40b92c211a34a6b3307e0db9d74a81a.svg";
export { ForwardRef as ReactComponent };